// base react-slick 0.23.2
import Slider from './slider';

export default Slider;